/** Mirrors backend caribbean_islands.py — 15 destinations with map centers. */
export const CARIBBEAN_ISLANDS = [
  { code: "barbados", name: "Barbados", flag: "🇧🇧", center: { lat: 13.1939, lng: -59.5432 }, zoom: 11 },
  { code: "jamaica", name: "Jamaica", flag: "🇯🇲", center: { lat: 18.1096, lng: -77.2975 }, zoom: 9 },
  { code: "trinidad", name: "Trinidad & Tobago", flag: "🇹🇹", center: { lat: 10.6918, lng: -61.2225 }, zoom: 10 },
  { code: "bahamas", name: "Bahamas", flag: "🇧🇸", center: { lat: 25.0343, lng: -77.3963 }, zoom: 8 },
  { code: "stlucia", name: "St. Lucia", flag: "🇱🇨", center: { lat: 13.9094, lng: -60.9789 }, zoom: 11 },
  { code: "antigua", name: "Antigua & Barbuda", flag: "🇦🇬", center: { lat: 17.0608, lng: -61.7964 }, zoom: 11 },
  { code: "grenada", name: "Grenada", flag: "🇬🇩", center: { lat: 12.1165, lng: -61.679 }, zoom: 11 },
  { code: "stvincent", name: "St. Vincent", flag: "🇻🇨", center: { lat: 13.2528, lng: -61.1971 }, zoom: 11 },
  { code: "dominica", name: "Dominica", flag: "🇩🇲", center: { lat: 15.415, lng: -61.371 }, zoom: 11 },
  { code: "curacao", name: "Curaçao", flag: "🇨🇼", center: { lat: 12.1696, lng: -68.99 }, zoom: 11 },
  { code: "aruba", name: "Aruba", flag: "🇦🇼", center: { lat: 12.5211, lng: -69.9683 }, zoom: 11 },
  { code: "cayman", name: "Cayman Islands", flag: "🇰🇾", center: { lat: 19.3133, lng: -81.2546 }, zoom: 10 },
  { code: "usvi", name: "US Virgin Islands", flag: "🇻🇮", center: { lat: 18.3358, lng: -64.8963 }, zoom: 11 },
  { code: "bvi", name: "British Virgin Islands", flag: "🇻🇬", center: { lat: 18.4207, lng: -64.64 }, zoom: 11 },
  { code: "puerto_rico", name: "Puerto Rico", flag: "🇵🇷", center: { lat: 18.2208, lng: -66.5901 }, zoom: 9 },
];

export const ISLAND_BY_CODE = Object.fromEntries(
  CARIBBEAN_ISLANDS.map((island) => [island.code, island])
);
